import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-step-summary',
  templateUrl: './step-summary.component.html',
  styleUrls: ['./step-summary.component.scss']
})
export class StepSummaryComponent implements OnInit {
  checkerPath: string = `${environment.hRef}assets/fi_check.png`;
  MileleLogoPath: string  = `${environment.hRef}assets/Milele_logo_white.png`;
  logoPath: string  = `${environment.hRef}assets/logo_w.png`;
  
  title: string = 'Your appointment request has been received.';

  text1: string = 'Our representative will contact you within 48 hours in order to confirm your appointment.';
  text2: string = 'Please note that the requested time may be adjusted according to availability and office hours.';
  
  buttonText: string = 'Done';
  powerdByText: string = 'Powered by ICEA LION Group. All rights reserved.';

  email: string = 'Test@gmail.com';

  data: any = null;


  constructor(
    private estateControlService: EstateControlService,
    private router: Router
  ) {
    
  }
  
  async ngOnInit(): Promise<void> {
    const data = await this.estateControlService.getData(this.estateControlService.storageKeyAppointment);

    if (data) {
      this.data = data;
    } else {
      this.goHome();
    }
  }

  get settlors(): any {
    return this.estateControlService.settlors;
  }

  async goHome(): Promise<void> {
    this.estateControlService.clearServiceRecords();
    this.estateControlService.clearData(this.estateControlService.storageKeyAppointment);
    const nextPage = ``;
    this.router.navigate([nextPage]);
  }
}
